// biome-ignore-all lint/style/useNamingConvention: all external data
import * as z from 'zod/mini';
import { isValidUsZipCode } from '@/app_lib/utils/utils';

export const RatesData = z.object({
  advertiser_notes: z.string(),
  apy: z.number(),
  effective_at: z.string(),
  ep_url: z.string(),
  institution: z.object({
    insurance_information: z.object({
      disclosure: z.string(),
      type: z.string(),
    }),
    logo_url: z.string(),
    name: z.string(),
    reviews: z.object({
      link: z.nullable(z.string()),
      overall_rating: z.nullable(z.number()),
      short_summary: z.nullable(z.string()),
      website_url: z.nullable(z.string()),
    }),
  }),
  is_local: z.boolean(),
  is_national: z.boolean(),
  is_paid: z.boolean(),
  max_to_open: z.nullable(z.number()),
  min_to_open: z.number(),
  pixel_url: z.string(),
  product: z.object({
    name: z.string(),
    term: z.optional(z.number()),
    type: z.string(),
  }),
  rate: z.number(),
});

export type RatesData = z.infer<typeof RatesData>;

export const CdRatesResponse = z.object({
  cd_rates: z.array(RatesData),
});

export type CdRatesResponse = z.infer<typeof CdRatesResponse>;

export const SavingsMmaResponse = z.object({
  savings_mma_rates: z.array(RatesData),
});

export type SavingsMmaResponse = z.infer<typeof SavingsMmaResponse>;

export const FilterBy = z.object({
  accountType: z.string(),
  depositAmount: z.number(),
  maxTermLength: z.number(),
  minTermLength: z.number(),
  zip: z.string().check(z.refine(isValidUsZipCode, { message: 'Invalid US zip code' })),
});

export type FilterBy = z.infer<typeof FilterBy>;
